export enum SlotPathRenderMode {
  ScaleToFill = 'scale_to_fill',
  ScaleAspectFit = 'scale_aspect_fit',
}
